import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web--source/slate/Color";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import styled from "styled-components";
var RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP = getSpacing("1x");
var RESULTS_DROPDOWN_SECTION_HEADER_WRAPPER_PADDING_BOTTOM = getSpacing("1x");
export var InfoWrapper = styled(Column).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-bf4c2c68-0"
})([
    "flex:1;min-width:0;padding:",
    ";width:100%;"
], getSpacing(0, 0, 0, "2x"));
export var ResultsDropdownView = styled.div.withConfig({
    componentId: "sc-bf4c2c68-1"
})([
    "max-height:93vh;",
    "{height:100vh;}background:",
    ";z-index:80;",
    " position:absolute;top:",
    "px;width:",
    "px;overflow-y:auto;box-shadow:0 1px 1px 0px ",
    ";h5{margin:4px 0 0 18px !important;",
    "}> div:first-of-type h5{margin-top:0;}strong{",
    " min-width:0;}span{",
    " min-width:0;}> div:last-of-type{padding-top:",
    ";}box-shadow:0 7px 10px ",
    ";@media screen and (max-width:767px){top:",
    "px;left:0;right:0;width:auto;bottom:0;}"
], responsiveMediaQueries.mobile, Core.surface.inverse, TypographyStyles({
    as: undefined
}), function(props) {
    return props.$top;
}, function(props) {
    return props.$width;
}, Core.surface.subdued, TypographyStyles({
    as: undefined
}), TypographyStyles({
    truncate: true,
    variant: "paragraphSansMedium"
}), TypographyStyles({
    truncate: true
}), RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP, Core.surface.enabled + Opacity.O_10, function(props) {
    return props.$height;
});
export var ResultsDropdownSectionsWrapper = styled.div.withConfig({
    componentId: "sc-bf4c2c68-2"
})([
    "padding-top:",
    ";"
], RESULTS_DROPDOWN_SECTIONS_WRAPPER_PADDING_TOP);
export var ResultsDropdownSectionHeaderWrapper = styled(Row).withConfig({
    componentId: "sc-bf4c2c68-3"
})([
    "padding-bottom:",
    ";"
], RESULTS_DROPDOWN_SECTION_HEADER_WRAPPER_PADDING_BOTTOM);
